// extracted by css-extract-rspack-plugin
export default {"closeButton":"_8516ae62"};